export const Tags = {
  Positive: [
    'onTimeDelivery',
    'excellentCodeQuality',
    'clearAndCompleteDocumentation',
    'excellentTechnicalSupport',
    'efficientCommunication',
    'wellDevelopedFeatures',
    'excellentPerformance',
    'veryEasyToUse',
    'wellExecutedTests',
    'exceptionalService'
  ],
  Negative: [
    'deliveryDelay',
    'codeQuality',
    'insufficientDocumentation',
    'technicalSupport',
    'communicationFailure',
    'incompleteFeatures',
    'slowPerformance',
    'difficultyOfUse',
    'qualityIssues',
    'unsatisfactoryService'
  ]
}
